var exports = {
  "k": "xe533113f--615de8--container",
  "P": "xe533113f--615de8--label",
};

module.exports = exports;
